module.exports = __webpack_public_path__ + "img/text4.6ceac5ea.png";